module.exports = __webpack_public_path__ + "img/ygab.d0289dc0.png";